define('services/config/orgConfigService',[
    'lib/lodash4',
    'services/apiCore',
    'models/config/Organization'
], function (_, apiCore, Organization) {
    'use strict';

    var ORGANIZATION_ENDPOINT = "/organizations/me";

    var orgConfigService = {

        getOrganization: function () {
            return apiCore.v2.get(ORGANIZATION_ENDPOINT)
                .then(function (organization) {
                    return new Organization(organization);
                });
        },

        updateOrganization: function (organization) {
            return apiCore.v2.put(ORGANIZATION_ENDPOINT, organization.unwrap())
                .then(function (organization) {
                    return new Organization(organization);
                });
        }

    };

    return orgConfigService;
});

